document.addEventListener('DOMContentLoaded', function() {
    const timelineItems = document.querySelectorAll('.timeline-item');
    timelineItems.forEach(item => {
        item.addEventListener('click', function() {
            const hiddenContent = this.querySelector('.content');
            hiddenContent.classList.toggle('hidden');
        });
    });

    const form = document.getElementById('quit-smoking-quiz');
    form.addEventListener('submit', function(event) {
        event.preventDefault();
        calculateResult();
    });
});



function calculateResult() {
    event.preventDefault();

    const cigarettesDaily = document.getElementById('cigarettesDaily').value;
    const consideredMethod = document.getElementById('consideredMethod').value;

    const costPerWeek = (cigarettesDaily / 20) * 13 * 7;
    const vapeCostPerWeek = (cigarettesDaily / 20) * 1.99 * 7 + 20 / 7;
    const savings = costPerWeek - vapeCostPerWeek;

    let additionalInfo = '';
    let resultContent = '';

    if (consideredMethod === 'medication') {
        additionalInfo = '<p>🔗 For medication options to quit smoking, visit the <a href="https://www.nhs.uk/conditions/stop-smoking-treatments/" target="_blank">NHS Stop Smoking Treatments</a> page.</p>';
        resultContent = `
            ${additionalInfo}
            <p>If you are considering switching to vaping after using medication, you can save a significant amount. 💰 Estimated Savings per Week: <strong>£${savings.toFixed(2)}</strong></p>
        `;
    } else if (consideredMethod === 'therapy') {
        additionalInfo = '<p>🔗 For therapy options to quit smoking, visit the <a href="https://www.nhs.uk/live-well/quit-smoking/nhs-stop-smoking-services-help-you-quit/" target="_blank">NHS Stop Smoking Services</a> page.</p>';
        resultContent = `
            ${additionalInfo}
            <p>If you are considering switching to vaping after therapy, you can save a significant amount. 💰 Estimated Savings per Week: <strong>£${savings.toFixed(2)}</strong></p>
        `;
    } else {
        const vapeKits = [
            '<a href="https://wizvape.co.uk/products/vaporesso-xros-2-pod-vape-kit" target="_blank">Vaporesso Xros 2 Pod Kit</a>',
            '<a href="https://wizvape.co.uk/products/vaporesso-xros-3-vape-kit" target="_blank">Vaporesso Xros 3 Pod Kit</a>',
            '<a href="https://wizvape.co.uk/products/aspire-pockex-kit" target="_blank">Aspire Pockex Starter Kit</a>',
            '<a href="https://wizvape.co.uk/products/innokin-endura-t18e-kit" target="_blank">Innokin T18E Starter Kit</a>',
            '<a href="https://wizvape.co.uk/products/innokin-endura-t22e-kit" target="_blank">Innokin T22E Starter Kit</a>'
        ];

        const eLiquids = [
            'QuitterZ High PG Menthol (Harsher Throat Hit)',
            'QuitterZ High PG Tobacco (Harsher Throat Hit)',
            'Romance 50 PG Menthol (Smoother Throat Hit)',
            'Romance 50 PG Tobacco (Smoother Throat Hit)',
            'Romance Nic Salt Menthol (Smoother Throat Hit)',
            'Romance Nic Salt Tobacco (Smoother Throat Hit)'
        ];

        let nicotineStrength;
        if (cigarettesDaily <= 5) nicotineStrength = '3mg';
        else if (cigarettesDaily <= 10) nicotineStrength = '6mg';
        else if (cigarettesDaily <= 19) nicotineStrength = '12mg';
        else nicotineStrength = '18mg';

        const randomVapeKit = vapeKits[Math.floor(Math.random() * vapeKits.length)];
        const randomELiquid = eLiquids[Math.floor(Math.random() * eLiquids.length)];

        resultContent = `
            <p>🌟 Best Vape Kit for You: <strong>${randomVapeKit}</strong></p>
            <p>🌟 Recommended Nicotine Strength: <strong>${nicotineStrength}</strong></p>
            <p>🌟 Recommended E-Liquid: <strong>${randomELiquid}</strong></p>
            <p>💷 Estimated Costs for Vaping per Week: <strong>£${vapeCostPerWeek.toFixed(2)}</strong></p>
            <p>💰 Estimated Savings per Week: <strong>£${savings.toFixed(2)}</strong></p>
        `;
    }

    document.getElementById('result').innerHTML = resultContent;
}